/* eslint-disable no-unused-vars */
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { useEffect, useMemo, useState } from 'react';
import { titleCase } from '../../utils/helpers';

function DokanItemsFilterbyStatus({
    label,
    queryParameterValue,
    queryParameterKey,
    defaultActiveLabel,
}) {
    const { pathname, search } = useLocation();
    const history = useHistory();

    // prepare query-string parameter
    const prepareQueryString = (qParamObj) => new URLSearchParams(qParamObj);
    const handleSearchByStatus = (qParam) => {
        if (qParam[queryParameterKey]) {
            const queryParameter = prepareQueryString(qParam);
            //   console.log(queryParameter.get('status'));

            // const prepareNewUrl = `${pathname}?${queryParameter}`;
            const newURL = queryString.stringifyUrl({
                url: pathname + search,
                query: qParam,
            });
            history.replace(newURL);
        } else history.replace(pathname);
    };

    const url = new URLSearchParams(useLocation().search);
    const isActive = url.get(queryParameterKey) || defaultActiveLabel;

    return (
        <>
            <button
                type="button"
                className={`mr-5 focus:outline-none ${
                    isActive === queryParameterValue
                        ? 'border-b-3px border-blue-dodger pb-5px text-dark'
                        : 'text-secondary'
                }`}
                onClick={() =>
                    handleSearchByStatus({
                        [queryParameterKey]: queryParameterValue,
                        // page: 1,
                    })
                }
            >
                {titleCase(label)}
            </button>
        </>
    );
}

export default DokanItemsFilterbyStatus;
